module.exports = __webpack_public_path__ + "img/COMBO RADIO RED.f73c9b8.svg";